<script>
    import Svgo from "./svgo.svelte";
</script>

<Svgo {...$$props} on:click>
    <path
            d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.9316 10.0476C17.4002 9.57892 17.4002 8.81912 16.9316 8.3505C16.463 7.88187 15.7032 7.88187 15.2346 8.3505L10.4769 13.1082L8.84882 11.4802C8.38019 11.0115 7.62039 11.0115 7.15176 11.4802C6.68314 11.9488 6.68314 12.7086 7.15177 13.1772L9.43564 15.4611C9.47768 15.5031 9.52206 15.5414 9.56837 15.5759C9.58927 15.6005 9.61132 15.6244 9.63453 15.6476C10.1032 16.1162 10.863 16.1162 11.3316 15.6476L16.9316 10.0476Z"
            fill="white"
        />
</Svgo>
